import React from 'react';

import { ModalContainer } from 'components/guardedModal/ModalContainer';
import { SimpleModalId } from 'constants/modalId';
import { ActionLogContentContainer } from './ActionLogContentContainer';
import { ActionLogModalProps } from './ActionLogContent.types';

export const ActionLogModal = (props: ActionLogModalProps) => (
  <ModalContainer id={SimpleModalId.ActionLog}>
    <ActionLogContentContainer {...props} />
  </ModalContainer>
);
